import { useState } from "react";
import { StyledTableBisManualPag } from "@/components/styled/StyledTableBisManualPag";
import { useGetLitigeV1 } from "@/api/invoice";
import { LitigeDeleteModal } from "./litigeDeleteModal";
import usePagination from "@/hooks/useSyncedPagination";
import { useLitigeTableColumns } from "./litigeTabeColumns";
import { useDisplayDocument } from "@/hooks/useDisplayDocument";

export const LitigeTable = () => {
  const [pagination, setPagination] = usePagination("litige");
  const [invoiceToDeleteId, setInvoiceToDeleteId] = useState<string>();

  const { displayDocument } = useDisplayDocument();
  const columns = useLitigeTableColumns(displayDocument, setInvoiceToDeleteId);

  const { data: litiges } = useGetLitigeV1({
    take: pagination.pageSize,
    skip: pagination.pageIndex * pagination.pageSize,
  });

  return (
    <>
      <StyledTableBisManualPag
        data={litiges?.data || []}
        columns={columns}
        setPagination={setPagination}
        pagination={pagination}
        rowCount={litiges?.count || 0}
      />
      <LitigeDeleteModal
        closeModal={() => setInvoiceToDeleteId(undefined)}
        litigeId={invoiceToDeleteId || ""}
        isOpen={!!invoiceToDeleteId}
      />
    </>
  );
};
